import {
	Autocomplete,
	createTheme,
	TextField,
	ThemeProvider,
	FormControl,
	FormLabel,
	RadioGroup,
	FormControlLabel,
	Radio,
} from "@mui/material";
import React, { Component } from "react";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import { withRouter } from "../../components/withRouter";
import {
	getStores,
	getAllCountries,
	getPO,
	getSequenceLabel,
	PathCustom,
} from "../../Path/Path";
import BulkPrintingModal from "../BulkPrintingModal";
import { HeadAndRowBulk } from "../../components/Helper";
import PermissionsModal from "../../components/PermissionsModal";
import { Print_Service } from "../../components/printService";
import axios from "axios";
import jwtDecode from "jwt-decode";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Barcode from "react-barcode";

// ZPL Template for Box Label Printing
const ZPL_TEMPLATE = `^XA~TA000~JSN^LT0^MNW^MTT^PON^PMN^LH0,0^JMA^PR5,5~SD15^JUS^LRN^CI0^XZ
^XA
^MMT
^PW799
^LL0599
^LS0
^BY3,3,200^FT160,250^BCN,,Y,N
^FD>:{barcode}^FS
^FT120,340^A0N,30,30^FH^FDArticle No: {articleCode}^FS
^FT120,390^A0N,30,30^FH^FDPO No: {poNumber}^FS
^FT443,390^A0N,30,30^FH^FDVendor Code: {vendorCode}^FS
^FT120,445^A0N,30,30^FH^FDNW: {netWeight}^FS
^FT443,445^A0N,30,30^FH^FDGW: {grossWeight}^FS
^FT129,550^A0N,30,30^FH^FD{manufacturingCountry}^FS
^PQ1,0,1,Y^XZ`;

class BoxLabelPrinting extends Component {
	previewRef = React.createRef();
	debounceTimer = null;

	state = {
		loading: false,
		countryData: [],
		storeArray: [],
		storeName: "",
		countryName: "",
		PoArray: [],
		PO_Number: "",
		countriesArray: [],
		prefix: "",
		storeId: "",
		printerCount: "1",
		PO_Vendor: "",
		printer: null,
		availablePrinters: [],
		manufacturingCountry: "China", // Default to China
		userName: "",
		previewData: null,
		previewDataArray: [], // Array of preview items
		previewZpl: "",
		cartonNumber: "",
	};

	async componentDidMount() {
		try {
			const stores = await getStores();
			// const po = await getPO();
			this.setState({
				storeArray: stores,
				// PoArray: po.data.data,
			});
			const data = await getAllCountries();

			this.setState({
				countryData: data.data?.data,
				countriesArray: data,
			});
			if (this.props.location.state?.item) {
				const item = this.props.location.state.item;
				this.setState({
					countryName: item?.name,
					countryCode: item?.code,
					prefix: item?.prefix,
				});
			}

			const user = await localStorage.getItem("loginData");
			const parseData = JSON.parse(user);
			const token = parseData?.token;
			if (token) {
				const decodetoken = jwtDecode(token);
				this.setState({ userName: decodetoken?.payload?.name })
			}

			// Discover available printers
			this.discoverPrinters();
		} catch (error) {
			console.error("Error:", error);
		}
	}

	discoverPrinters = () => {
		if (window.BrowserPrint) {
			window.BrowserPrint.getLocalDevices(
				(deviceList) => {
					const printers = deviceList.printer || [];
					this.setState({ availablePrinters: printers });
				},
				(error) => {
					console.error("Error discovering printers:", error);
				}
			);
		}
	};

	fetchBoxLabelByBarcode = async (barcode) => {
		if (!barcode || barcode.trim() === "") {
			return;
		}

		try {
			this.setState({ loading: true });
			const { data } = await axios.get(
				`${PathCustom}store/box-label-printed-items/by-barcode?barcode=${barcode}`
			);

			if (data?.data) {
				const item = data.data;
				const poNumber = item.poNumber || "";
				const storeId = item.storeId || "";

				// Normalize manufacturing country to title case (e.g., "CHINA" -> "China")
				const normalizeCountry = (country) => {
					if (!country) return "China";
					const upper = country.toUpperCase();
					if (upper === "CHINA") return "China";
					if (upper === "INDIA") return "India";
					return country.charAt(0).toUpperCase() + country.slice(1).toLowerCase();
				};

				// First, set basic fields
				this.setState({
					storeId: storeId,
					PO_Number: poNumber,
					countryName: item.country || "",
					prefix: item.prefix || "",
					manufacturingCountry: normalizeCountry(item.manufactureCountry),
				});

				this.setState({ loading: false });


				toast.success("Box label information loaded successfully");
			} else {
				this.setState({ loading: false });
				toast.error("No record found for this carton number");
			}
		} catch (error) {
			this.setState({ loading: false });
			toast.error("Failed to fetch box label information");
			console.error("Error fetching box label:", error);
		}
	};

	handleCartonNumberChange = (e) => {
		const value = e.target.value;
		// Only allow alphanumeric characters (letters and numbers)
		const alphanumericValue = value.replace(/[^a-zA-Z0-9]/g, '');
		
		// Clear existing timer
		if (this.debounceTimer) {
			clearTimeout(this.debounceTimer);
		}

		// If carton number is cleared, clear all fields that were populated from it
		if (!alphanumericValue || alphanumericValue.trim() === "") {
			this.setState({
				cartonNumber: "",
				storeId: "",
				PO_Number: "",
				countryName: "",
				prefix: "",
				manufacturingCountry: "China",
				PO_Vendor: "",
				PoArray: [],
				previewData: null,
				previewDataArray: [],
			});
			return;
		}

		// Set carton number
		this.setState({ cartonNumber: alphanumericValue });

		// Set new timer for debounce (500ms delay)
		this.debounceTimer = setTimeout(() => {
			if (alphanumericValue && alphanumericValue.trim() !== "") {
				// Clear fields before fetching new data from carton number
				this.setState({
					storeId: "",
					PO_Number: "",
					countryName: "",
					prefix: "",
					manufacturingCountry: "China",
					PO_Vendor: "",
					PoArray: [],
					previewData: null,
					previewDataArray: [],
				});
				this.fetchBoxLabelByBarcode(alphanumericValue.trim());
			}
		}, 500);
	};

	componentWillUnmount() {
		// Clear timer on unmount
		if (this.debounceTimer) {
			clearTimeout(this.debounceTimer);
		}
	}

	printLabel = async (barcode, saveToDb = false) => {
		const {
			PO_Number,
			PO_Vendor,
			manufacturingCountry,
			storeId,
			countryName,
			prefix,
			printer,
			userName,
		} = this.state;

		const updatedBarcode = barcode.toString();

		// Replace variables in ZPL template
		let zpl = ZPL_TEMPLATE.replace(/{barcode}/g, updatedBarcode)
			.replace(/{poNumber}/g, PO_Number || "")
			.replace(/{vendorCode}/g, PO_Vendor || "")
			.replace(/{articleCode}/g, "")
			.replace(/{cartonNumber}/g, updatedBarcode)
			.replace(/{netWeight}/g, "")
			.replace(/{grossWeight}/g, "")
			.replace(
				/{manufacturingCountry}/g,
				`Made in ${manufacturingCountry.toUpperCase()}`
			);

		// Save to DB only if saveToDb is true (for new labels, not reprints)
		if (saveToDb) {
			const body = {
				storeId: storeId,
				poNumber: PO_Number,
				country: countryName,
				prefix: prefix,
				manufactureCountry: manufacturingCountry.toUpperCase(),
				barcode: updatedBarcode,
				user: userName,
				vendorCode: PO_Vendor || "",
			};
			await axios.post(`${PathCustom}store/box-label-printed-items`, body);
		}

		// Print the ZPL
		Print_Service.print(printer, zpl);
	};

	storeHandler = async (selectedStore) => {
		try {
			this.setState({ storeId: selectedStore, loading: true });
			const params = {
				PO_Site: selectedStore
			};
			const po = await getPO(params);
			this.setState({
				PoArray: po.data.data,
				loading: false
			});
			const countriesData = this.state.countriesArray.data.data;

			const selectedCountry = this.state.storeArray.find(
				(store) => store.Warehouse === selectedStore
			)?.Country;

			if (
				!this.state.countriesArray ||
				this.state.countriesArray.length === 0
			) {
				this.setState({ loading: true });
				const data = await getAllCountries();
				this.setState({ countriesArray: data, loading: false });
			}
			const countryData = countriesData?.find(
				(country) => country.name === selectedCountry
			);

			const prefix = countryData?.prefix || "";

			this.setState({ prefix: prefix, countryName: countryData.name });
		} catch (error) {
			this.setState({ loading: false, countryName: "", prefix: "" });
			console.error("Error:", error);
		}
	};

	printHandler = async () => {
		const quantity = this.state.printerCount;
		const {
			countryName,
			prefix,
			PO_Number,
			storeId,
			printer,
			PO_Vendor,
			manufacturingCountry,
			cartonNumber,
		} = this.state;

		if(cartonNumber && !storeId && !PO_Number && !prefix && !countryName) {
			toast.error("Please enter valid Carton Number to reprint");
			return;
		}

		if (storeId === null || storeId === undefined || storeId === "") {
			toast.error("Please select Store");
			return;
		}
		if (PO_Number === null || PO_Number === undefined || PO_Number === "") {
			toast.error("Please select PO Number");
			return;
		}
		if (
			countryName === null ||
			countryName === undefined ||
			countryName === ""
		) {
			toast.error("Please select Store");
			return;
		}
		if (prefix === null || prefix === undefined || prefix === "") {
			toast.error(
				`Prefix not found for ${countryName}. Please add it before proceeding.`
			);
			return;
		}
		if (printer === null || printer === undefined) {
			toast.error("Please select a printer");
			return;
		}
		if (quantity < 1 || quantity === "" || quantity === undefined) {
			toast.error("Please enter quantity");
			return;
		} else {
			try {
				this.setState({ loading: true });

				// If carton number is provided, use it directly without sequence API and DB save
				if (cartonNumber && cartonNumber.trim() !== "") {
					const barcode = cartonNumber.trim();
					await this.printLabel(barcode, false); // false = don't save to DB

					this.setState({
						loading: false,
						printerCount: "1",
					});
					toast.success("Label sent to printer successfully!");
					return;
				}

				// If no carton number, call sequence API and save to DB
				const params = {
					increment: parseInt(this.state.printerCount),
					storeId: this.state.storeId,
				};
				const res = await getSequenceLabel(params);
				if (res.data.length === 0 || res.data.length === "") {
					toast.error("Store not found");
					this.setState({ loading: false });
					return;
				}

				// Generate and print ZPL for each barcode
				for (let i = 0; i < res.data.length; i++) {
					const barcode = res.data[i];
					await this.printLabel(barcode, true); // true = save to DB
				}

				this.setState({
					loading: false,
					printerCount: "1",
				});
				toast.success("Labels sent to printer successfully!");
			} catch (error) {
				this.setState({ loading: false, printerCount: "1" });
				toast.error("Something went wrong");
				console.error("Error while printing label:", error);
			}
		}
	};

	parsePositiveInteger = (input) => {
		if (/^\d+$/.test(input) && !input.includes(".") && parseInt(input) > 0) {
			return parseInt(input);
		} else {
			return null;
		}
	};

	generatePreview = async () => {
		const {
			storeId,
			PO_Number,
			countryName,
			prefix,
			PO_Vendor,
			manufacturingCountry,
			printerCount,
			cartonNumber,
		} = this.state;

		if(cartonNumber && !storeId && !PO_Number && !prefix && !countryName) {
			toast.error("Please enter valid Carton Number to generate preview");
			return;
		}

		if (!storeId && !cartonNumber) {
			toast.error("Please select Store or enter Carton Number");
			return;
		}
		if (!PO_Number && !cartonNumber) {
			toast.error("Please select PO Number");
			return;
		}
		if (!prefix && !cartonNumber) {
			toast.error("Prefix not found");
			return;
		}

		try {
			this.setState({ loading: true });
			const quantity = parseInt(printerCount) || 1;

			// If carton number is provided, use it for single preview
			if (cartonNumber && cartonNumber.trim() !== "") {
				const barcode = cartonNumber.trim();
				const previewItem = {
					barcode,
					articleCode: "",
					poNumber: PO_Number || "",
					vendorCode: PO_Vendor || "",
					netWeight: "",
					grossWeight: "",
					manufacturingCountry: `Made in ${manufacturingCountry.toUpperCase()}`,
				};

				this.setState({
					loading: false,
					previewData: previewItem,
					previewDataArray: [previewItem],
				});
				toast.success("Preview generated successfully");
				return;
			}

			// Call sequence API to get unique barcodes
			const params = {
				increment: quantity,
				storeId: storeId,
			};
			const res = await getSequenceLabel(params);
			if (!res.data || res.data.length === 0) {
				toast.error("Store not found or unable to generate sequences");
				this.setState({ loading: false });
				return;
			}

			const barcodes = res.data;
			const previewItems = [];
			const savedItems = [];

			// Generate preview data for each barcode and save to DB
			for (let i = 0; i < barcodes.length; i++) {
				const barcode = barcodes[i].toString();

				const previewItem = {
					barcode,
					articleCode: "",
					poNumber: PO_Number || "",
					vendorCode: PO_Vendor || "",
					netWeight: "",
					grossWeight: "",
					manufacturingCountry: `Made in ${manufacturingCountry.toUpperCase()}`,
				};

				previewItems.push(previewItem);

				// Save to DB (same as printHandler)
				try {
					const body = {
						storeId: storeId,
						poNumber: PO_Number,
						country: countryName,
						prefix: prefix,
						manufactureCountry: manufacturingCountry.toUpperCase(),
						barcode: barcode,
						user: this.state.userName,
						PO_Vendor: PO_Vendor || "",
					};
					await axios.post(`${PathCustom}store/box-label-printed-items`, body);
					savedItems.push(barcode);
				} catch (dbError) {
					console.error(`Error saving barcode ${barcode}:`, dbError);
				}
			}

			this.setState({
				loading: false,
				previewData: previewItems[0], // First item for single preview display
				previewDataArray: previewItems,
			});

			toast.success(
				`${previewItems.length} preview(s) generated and saved successfully`
			);
		} catch (error) {
			this.setState({ loading: false });
			toast.error("Unable to generate preview");
			console.error("Error while generating preview:", error);
		}
	};

	downloadPreviewPdf = async () => {
		const { previewDataArray, PO_Number } = this.state;

		if (!previewDataArray || previewDataArray.length === 0) {
			toast.error("No preview data available");
			return;
		}

		try {
			this.setState({ loading: true });
			const pdf = new jsPDF("p", "mm", "a4");
			const pdfWidth = pdf.internal.pageSize.getWidth();
			const pdfHeight = pdf.internal.pageSize.getHeight();

			// 2 labels per row, 3 rows per page = 6 labels per page
			const labelsPerRow = 2;
			const rowsPerPage = 3;
			const labelsPerPage = labelsPerRow * rowsPerPage;

			const labelWidth = (pdfWidth - 20) / labelsPerRow; // With margins
			const labelHeight = (pdfHeight - 20) / rowsPerPage; // With margins

			// Find all preview label elements in the DOM
			const previewElements = document.querySelectorAll('.preview-label-item');

			for (let i = 0; i < previewDataArray.length; i++) {
				const previewItem = previewDataArray[i];

				// Find the corresponding DOM element
				let labelElement = null;
				if (previewElements.length > i) {
					labelElement = previewElements[i];
				} else {
					// If element not found, create a temporary one
					labelElement = document.createElement("div");
					labelElement.className = "preview-label-item";
					labelElement.style.position = "absolute";
					labelElement.style.left = "-9999px";
					labelElement.style.width = "400px";
					labelElement.style.border = "1px solid #ccc";
					labelElement.style.padding = "20px";
					labelElement.style.background = "#fff";
					labelElement.style.color = "#000";
					labelElement.style.display = "flex";
					labelElement.style.flexDirection = "column";

					labelElement.innerHTML = `
						<div style="text-align: center; margin-bottom: 30px;">
							<svg id="barcode-svg-${i}"></svg>
						</div>
						<div style="display: flex; justify-content: space-between; margin-bottom: 20px;">
							<div style="flex: 1;">
								<p style="color: #000; font-size: 14px; font-weight: bold; margin-bottom: 12px;">
									Article No: ${previewItem.articleCode || ""}
								</p>
								<p style="color: #000; font-size: 14px; font-weight: bold; margin-bottom: 12px;">
									PO No: ${previewItem.poNumber}
								</p>
								<p style="color: #000; font-size: 14px; font-weight: bold;">
									NW: ${previewItem.netWeight || "-"}
								</p>
							</div>
							<div style="flex: 1; text-align: right;">
								<p style="color: #000; font-size: 14px; font-weight: bold; margin-bottom: 12px;">
									Vendor Code: ${previewItem.vendorCode}
								</p>
								<p style="color: #000; font-size: 14px; font-weight: bold;">
									GW: ${previewItem.grossWeight || "-"}
								</p>
							</div>
						</div>
						<div>
							<p style="color: #000; font-size: 14px; font-weight: bold;">
								${previewItem.manufacturingCountry}
							</p>
						</div>
					`;
					document.body.appendChild(labelElement);

					// Render barcode using JsBarcode if available, or use text
					setTimeout(() => {
						const barcodeSvg = labelElement.querySelector(`#barcode-svg-${i}`);
						if (barcodeSvg && window.JsBarcode) {
							window.JsBarcode(barcodeSvg, previewItem.barcode, {
								format: "CODE128",
								width: 2,
								height: 60,
								displayValue: true,
								fontSize: 14,
							});
						} else if (barcodeSvg) {
							barcodeSvg.innerHTML = `<text x="50%" y="50%" text-anchor="middle" font-size="14">${previewItem.barcode}</text>`;
						}
					}, 100);
				}

				// Wait a bit for barcode to render if needed
				await new Promise(resolve => setTimeout(resolve, 200));

				// Convert element to canvas
				const canvas = await html2canvas(labelElement, {
					scale: 1.5, // lower scale to reduce output size
					useCORS: true,
					backgroundColor: "#ffffff",
					width: labelElement.offsetWidth || 400,
					height: labelElement.offsetHeight || 300,
				});
				
				const imgData = canvas.toDataURL("image/jpeg", 0.95); // JPEG with moderate quality to shrink file size

				// Calculate position on page
				const positionInPage = i % labelsPerPage;
				const row = Math.floor(positionInPage / labelsPerRow);
				const col = positionInPage % labelsPerRow;

				// Add new page if needed
				if (i > 0 && positionInPage === 0) {
					pdf.addPage();
				}

				// Calculate position with margins
				const x = col * labelWidth + 10;
				const y = row * labelHeight + 10;

				// Scale image to fit label size
				const imgWidth = labelWidth - 5;
				const imgHeight = (canvas.height * imgWidth) / canvas.width;

				// If height exceeds available space, scale down
				const finalHeight = imgHeight > labelHeight - 5 ? labelHeight - 5 : imgHeight;
				const finalWidth = (canvas.width * finalHeight) / canvas.height;

				pdf.addImage(imgData, "JPEG", x, y, finalWidth, finalHeight);

				// Clean up temporary element if created
				if (previewElements.length <= i && labelElement.parentNode) {
					document.body.removeChild(labelElement);
				}
			}

			pdf.save(`BoxLabel_${PO_Number || "preview"}_${previewDataArray.length}labels.pdf`);
			this.setState({ loading: false });
			toast.success(`PDF downloaded successfully with ${previewDataArray.length} label(s)`);
		} catch (error) {
			this.setState({ loading: false });
			toast.error("Unable to download preview as PDF");
			console.error("Error while downloading preview PDF:", error);
		}
	};

	render() {
		const {
			PoArray,
			availablePrinters,
			printer,
			manufacturingCountry,
			previewData,
			previewZpl,
		} = this.state;

		const darkTheme = createTheme({
			palette: {
				mode: "light",
			},
		});
		return (
			<React.Fragment>
				<Loader loading={this.state.loading} />
				<ThemeProvider theme={darkTheme}>
					<div className="dashboard-main">
						<div className="dashboard-top">
							<div>
								{" "}
								<p className="title-style"> Label Printing</p>
								<h1 style={{ color: "black", fontSize: "15px" }}>
									{new Date().toLocaleString("hi-IN")}
								</h1>
							</div>
						</div>
						<div className="bulk-main-div">
							<div
								className="bulk-bottom"
								style={{
									display: "flex",
									justifyContent: "center",
									gap: "40px",
								}}
							>
								<div className="white-box-1" style={{ minWidth: "360px", minHeight: "460px" }}>
									<div
										style={{
											display: "flex",
											justifyContent: "space-between",
											padding: "14px",
										}}
									>
										<div style={{ display: "flex", alignItems: "center" }}>
											<p className="total-score-tag1">Box Label Printing</p>
										</div>
									</div>

									<div
										style={{
											display: "flex",
											flexDirection: "column",
											paddingTop: "5px",
											paddingLeft: "3%",
											paddingRight: "3%",
											alignItems: "center",
										}}
									>
										<TextField
											sx={{ width: "100%", marginBottom: "10px" }}
											size={"small"}
											id="box-label-printing-carton"
											label="Carton Number"
											variant="outlined"
											value={this.state.cartonNumber}
											onChange={this.handleCartonNumberChange}
											placeholder="Enter carton number for reprinting"
										/>

										<Autocomplete
											disablePortal
											id="box-label-printing-store"
											size={"small"}
											disabled={this.state.cartonNumber}
											options={this.state.storeArray
												?.map((item) => item?.Warehouse)
												.reduce((noDupArr, entry) => {
													if (noDupArr?.includes(entry)) {
														return noDupArr;
													} else {
														return [...noDupArr, entry];
													}
												}, [])
												.filter((item) => item !== null && item !== undefined)}
											value={this.state.storeId || null}
											onChange={(e, v) => {
												if (v === null) {
													this.setState({
														PO_Number: "",
														PO_Vendor: "",
														PoArray: [],
														storeId: "",
													});
													this.setState({ countryName: null, prefix: null });
												} else {
													this.storeHandler(v);
												}
											}}
											sx={{ width: "100%", marginBottom: "10px" }}
											renderInput={(params) => (
												<TextField {...params} label="Store" />
											)}
										/>

										<Autocomplete
											// Re-render only when store or options list changes, not on each keystroke
											key={`po-${this.state.storeId || "no-store"}-${
												PoArray?.length || 0
											}`}
											disablePortal
											id="box-label-printing-po"
											disabled={this.state.cartonNumber}
											size="small"
											options={
											!this.state.storeId || !PoArray || PoArray.length === 0
											? []
											: PoArray.filter(
													(item) =>
														item?.PO_Number !== "" &&
														item?.PO_Number !== undefined
											)
												.map((item) => item?.PO_Number)
												.reduce((noDupArr, entry) => {
													if (noDupArr.includes(entry)) {
														return noDupArr;
													} else {
														return [...noDupArr, entry];
													}
												}, [])
											}
											value={this.state.PO_Number || null}
											onChange={(e, v) => {
												const selectedPO = PoArray?.find(
													(item) => item.PO_Number === v
												);
												this.setState({
													PO_Number: v ?? "",
													PO_Vendor: selectedPO ? selectedPO.PO_Vendor : "",
												});
											}}
											// Do not allow free text; user can only pick from dropdown
											onInputChange={() => {}}
											sx={{ width: "100%", marginBottom: "10px" }}
											renderInput={(params) => (
											<TextField
												{...params}
												label="PO Number"
												InputProps={{
													...params.InputProps,
													readOnly: true, // prevent manual typing
												}}
											/>
											)}
										/>

										<TextField
											sx={{
												width: "100%",
												marginBottom: "10px",
												color: "black",
											}}
											defaultValue={this.state.countryName}
											value={this.state.countryName || ""}
											placeholder={this.state.countryName}
											size={"small"}
											disabled
											id="box-label-printing-prefix"
											label={"Country Name"}
											variant="outlined"
										/>
										<TextField
											sx={{
												width: "100%",
												marginBottom: "10px",
												color: "black",
											}}
											defaultValue={this.state.prefix}
											value={this.state.prefix || ""}
											placeholder={this.state.prefix}
											size={"small"}
											disabled
											id="box-label-printing-prefix"
											label={"Prefix"}
											variant="outlined"
										/>
										<Autocomplete
											disablePortal
											id="box-label-printing-printer"
											size="small"
											options={availablePrinters.map((printer) => printer.name)}
											value={printer ? printer.name : ""}
											onChange={(e, v) => {
												const selectedPrinter = availablePrinters.find(
													(p) => p.name === v
												);
												this.setState({ printer: selectedPrinter });
											}}
											sx={{ width: "100%", marginBottom: "10px" }}
											renderInput={(params) => (
												<TextField {...params} label="Select Printer" />
											)}
										/>

										<TextField
											sx={{ width: "100%" }}
											type="number"
											value={this.state.printerCount || ""}
											placeholder="1"
											onChange={(e) => {
												const inputValue = e.target.value;
												// Allow empty string while typing, or valid positive integers
												if (inputValue === "" || this.parsePositiveInteger(inputValue)) {
												this.setState({
													printerCount: inputValue,
												});
												}
											}}
											onBlur={(e) => {
												// Validate on blur: if empty or 0, set to 1
												const value = parseInt(e.target.value) || 0;
												if (value < 1) {
													this.setState({
														printerCount: "1",
													});
												}
											}}
											size={"small"}
											id="box-label-printing-qty"
											label={"Quantity"}
											variant="outlined"
											disabled={this.state.cartonNumber}
										/>

										<FormControl
											component="fieldset"
											sx={{ width: "100%", marginTop: "10px" }}
										>
											<FormLabel
												component="legend"
												sx={{
													color: "black",
													fontSize: "14px",
													marginBottom: "8px",
												}}
											>
												Manufacturing Country
											</FormLabel>
											<RadioGroup
												row
												value={manufacturingCountry}
												onChange={(e) =>
													this.setState({
														manufacturingCountry: e.target.value,
													})
												}
												sx={{ justifyContent: "center" }}
											>
												<FormControlLabel
													value="China"
													control={<Radio size="small" />}
													label="China"
													sx={{ color: "black" }}
												/>
												<FormControlLabel
													value="India"
													control={<Radio size="small" />}
													label="India"
													sx={{ color: "black" }}
												/>
											</RadioGroup>
										</FormControl>
									</div>
								</div>
								<div className="white-box-1" style={{ maxWidth: "370px", minHeight: "460px", width: "100%", display: "flex", flexDirection: "column" }}>
									<div
										style={{
											display: "flex",
											justifyContent: "space-between",
											padding: "14px",
											flexShrink: 0,
										}}
									>
										<div style={{ display: "flex", alignItems: "center" }}>
											<p className="total-score-tag1">Label Preview</p>
										</div>
										<button
											onClick={this.downloadPreviewPdf}
											className="print-btn"
											disabled={!previewData && (!this.state.previewDataArray || this.state.previewDataArray.length === 0)}
										>
											<p className="print-text">
												Download PDF
											</p>
										</button>
									</div>

									<div
										style={{
											flex: 1,
											overflowY: "auto",
											overflowX: "hidden",
											padding: "0 20px 20px 20px",
											minHeight: 0,
										}}
									>
										{this.state.previewDataArray && this.state.previewDataArray.length > 0 ? (
											<div style={{
												display: "flex",
												flexDirection: "column",
												gap: "20px",
												width: "100%",
												paddingTop: "20px",
											}}>
												{this.state.previewDataArray.map((previewItem, index) => (
													<div
														key={index}
														ref={index === 0 ? this.previewRef : null}
														className="preview-label-item"
														data-index={index}
														style={{
															border: "1px solid #ccc",
															padding: "20px",
															background: "#fff",
															color: "#000",
															display: "flex",
															flexDirection: "column",
															width: "100%",
															maxWidth: "100%",
															boxSizing: "border-box",
															minWidth: 0,
														}}
													>
														{/* Barcode Section at Top */}
														<div
															style={{
																textAlign: "center",
																marginBottom: "30px",
																overflow: "hidden",
																width: "100%",
															}}
														>
															<Barcode
																value={previewItem.barcode}
																format="CODE128"
																width={2}
																height={60}
																displayValue={true}
																fontSize={14}
															/>
														</div>

														{/* Two Column Layout */}
														<div
															style={{
																display: "flex",
																justifyContent: "space-between",
																marginBottom: "20px",
																gap: "10px",
																width: "100%",
															}}
														>
															{/* Left Column */}
															<div style={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
																<p
																	style={{
																		color: "#000",
																		fontSize: "14px",
																		fontWeight: "bold",
																		marginBottom: "12px",
																		wordWrap: "break-word",
																		overflowWrap: "break-word",
																	}}
																>
																	Article No: {previewItem.articleCode || ""}
																</p>
																<p
																	style={{
																		color: "#000",
																		fontSize: "14px",
																		fontWeight: "bold",
																		marginBottom: "12px",
																		wordWrap: "break-word",
																		overflowWrap: "break-word",
																	}}
																>
																	PO No: {previewItem.poNumber}
																</p>
																<p
																	style={{
																		color: "#000",
																		fontSize: "14px",
																		fontWeight: "bold",
																		wordWrap: "break-word",
																		overflowWrap: "break-word",
																	}}
																>
																	NW: {previewItem.netWeight || "-"}
																</p>
															</div>

															{/* Right Column */}
															<div style={{ flex: 1, textAlign: "right", minWidth: 0, overflow: "hidden" }}>
																<p
																	style={{
																		color: "#000",
																		fontSize: "14px",
																		fontWeight: "bold",
																		marginBottom: "12px",
																		wordWrap: "break-word",
																		overflowWrap: "break-word",
																	}}
																>
																	Vendor Code: {previewItem.vendorCode}
																</p>
																<p
																	style={{
																		color: "#000",
																		fontSize: "14px",
																		fontWeight: "bold",
																		wordWrap: "break-word",
																		overflowWrap: "break-word",
																	}}
																>
																	GW: {previewItem.grossWeight || "-"}
																</p>
															</div>
														</div>

														{/* Manufacturing Country at Bottom */}
														<div>
															<p
																style={{
																	color: "#000",
																	fontSize: "14px",
																	fontWeight: "bold",
																}}
															>
																{previewItem.manufacturingCountry}
															</p>
														</div>
													</div>
												))}
											</div>
										) : previewData ? (
									<div
										ref={this.previewRef}
										style={{
											border: "1px solid #ccc",
											padding: "20px",
											background: "#fff",
											color: "#000",
													minHeight: "370px",
											display: "flex",
											flexDirection: "column",
													width: "100%",
													maxWidth: "100%",
													boxSizing: "border-box",
													minWidth: 0,
													marginTop: "20px",
										}}
									>
											<div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
												{/* Barcode Section at Top */}
												<div
													style={{
														textAlign: "center",
														marginBottom: "30px",
															overflow: "hidden",
															width: "100%",
													}}
												>
													<Barcode
														value={previewData.barcode}
														format="CODE128"
														width={2}
														height={60}
														displayValue={true}
														fontSize={14}
													/>
												</div>

												{/* Two Column Layout */}
												<div
													style={{
														display: "flex",
														justifyContent: "space-between",
														marginBottom: "20px",
															gap: "10px",
															width: "100%",
													}}
												>
													{/* Left Column */}
														<div style={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
														<p
															style={{
																color: "#000",
																fontSize: "14px",
																fontWeight: "bold",
																marginBottom: "12px",
																	wordWrap: "break-word",
																	overflowWrap: "break-word",
															}}
														>
															Article No: {previewData.articleCode || ""}
														</p>
														<p
															style={{
																color: "#000",
																fontSize: "14px",
																fontWeight: "bold",
																marginBottom: "12px",
																	wordWrap: "break-word",
																	overflowWrap: "break-word",
															}}
														>
															PO No: {previewData.poNumber}
														</p>
														<p
															style={{
																color: "#000",
																fontSize: "14px",
																fontWeight: "bold",
																	wordWrap: "break-word",
																	overflowWrap: "break-word",
															}}
														>
															NW: {previewData.netWeight || "-"}
														</p>
													</div>

													{/* Right Column */}
														<div style={{ flex: 1, textAlign: "right", minWidth: 0, overflow: "hidden" }}>
														<p
															style={{
																color: "#000",
																fontSize: "14px",
																fontWeight: "bold",
																marginBottom: "12px",
																	wordWrap: "break-word",
																	overflowWrap: "break-word",
															}}
														>
															Vendor Code: {previewData.vendorCode}
														</p>
														<p
															style={{
																color: "#000",
																fontSize: "14px",
																fontWeight: "bold",
																	wordWrap: "break-word",
																	overflowWrap: "break-word",
															}}
														>
															GW: {previewData.grossWeight || "-"}
														</p>
													</div>
												</div>

												{/* Manufacturing Country at Bottom */}
													<div>
													<p
														style={{
															color: "#000",
															fontSize: "14px",
															fontWeight: "bold",
														}}
													>
														{previewData.manufacturingCountry}
													</p>
													</div>
												</div>
											</div>
										) : (
											<p style={{ textAlign: "center", color: "#555", padding: "20px" }}>
												Fill the form on the left and click{" "}
												<strong>Preview Label</strong> to see a live preview
												here.
											</p>
										)}
									</div>
								</div>
							</div>
						</div>
						<div
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								marginTop: "24px",
								gap: "12px",
								marginBottom: "20px",
							}}
						>
							<button
								onClick={() => this.printHandler()}
								className="print-btn"
								// disabled={this.state.cartonNumber && !this.state.storeId && !this.state.PO_Number && !this.state.prefix && !this.state.countryName ? true : false}
							>
								<p className="print-text">
									{this.state.cartonNumber ? "Re Print Label" : "Print Labels"}
								</p>
							</button>
							<button
								onClick={this.generatePreview}
								className="print-btn"
							>
								<p className="print-text">Preview Label</p>
							</button>
						</div>
						{this.state.openModal && (
							<BulkPrintingModal
								tableTitle={"Barcode Detail 1"}
								modalOpen={!!this.state.openModal}
								closeHandler={this.closeModal}
								HeadAndRow={HeadAndRowBulk}
								data={this.state.openModal}
								subheading={"Site"}
								subHeadingValue={this.state.selectedSite}
								printer={this.state.printer}
								zplData={this.state.zplData}
								supplier={this.state.supplier}
								multiCurrency={this.state.allCurrency}
								madeInChina={this.state.madeInChina}
								withPrice={this.state.withPrice}
							/>
						)}

						<PermissionsModal
							open={this.state.articleModal}
							onClick={() => this.setState({ articleModal: false })}
							onClose={() => this.setState({ articleModal: false })}
							permissions={this.state.permissionArray}
						/>
					</div>
				</ThemeProvider>
			</React.Fragment>
		);
	}
}
export default withRouter(BoxLabelPrinting);
